import { render, staticRenderFns } from "./infoPublicity.vue?vue&type=template&id=37c42bf8&scoped=true"
import script from "./infoPublicity.vue?vue&type=script&lang=js"
export * from "./infoPublicity.vue?vue&type=script&lang=js"
import style0 from "./infoPublicity.vue?vue&type=style&index=0&id=37c42bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c42bf8",
  null
  
)

export default component.exports